import { useEffect, useRef, useState } from 'react';

/**
 * Хук для показа формы дорогих отелей на 2 и кадждый 10 раз открытия страницы
 * @param count Количество открытий страницы дорогого отеля
 * @param sigmaValue Значение которое управляет показом формы
 * @returns opened Состояние для показа формы
 * @returns setOpened Функция для имзенения состояния
 */
export const useOpen = (
  count: number,
  sigmaValue: number | string | undefined,
  pricePerNightPerPerson: number,
) => {
  const [isOpened, setIsOpened] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Таймаут нужен для корректной работы gtm аналитики при открытии баннера
    const timerId = setTimeout(() => {
      if (
        isFirstRender.current &&
        sigmaValue &&
        pricePerNightPerPerson >= Number(sigmaValue) &&
        (count - 2) % 20 === 0
      ) {
        setIsOpened(true);
        isFirstRender.current = false;
      }
    }, 900);

    return () => clearTimeout(timerId);
  }, [count, sigmaValue, pricePerNightPerPerson, isFirstRender]);

  return { isOpened, setIsOpened } as const;
};
